module.exports = __webpack_public_path__ + "47600deb2211a3dab0de9e8161a01539.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/backgrounds/cover-3.jpg
// module id = 393
// module chunks = 0